<template>
  <div>
    <!-- Ask fro confirmation !isOAuthDomainApproved(redirectURLHostName) -->
    <v-card v-if="false" class="elevation-7 card-style">
      <!-- Company Branding -->
      <CompanyBranding
      :company="company"
      ></CompanyBranding>
      <!-- Login/Sign up heading -->
      <!-- <v-card-title primary-title class="justify-center">
        <div class="display-1 primary--text font-weight-light">
          {{ $t("login.title") }}
        </div>
      </v-card-title> -->
      <!-- Content -->
      <v-stepper v-model="current_step">
        <v-stepper-items>
          <!-- Change password -->
          <v-stepper-content :step="DEFINES.ENROLLMENT_STEPS.ASK_APP_LOGIN_CONFIRMATION">
            <AskAppLoginConfirmation
            ref="askAppLoginConfirmation"
            @onCancel=""
            @onConfirm="onApprove"
            ></AskAppLoginConfirmation>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
  </div>
</template>
<script>
import DEFINES from "@/defines";
import { mapState, mapGetters } from "vuex";
import { userCountryCode } from "@/mixins/userCountryCode";
import { consumerAuthentication } from "@/mixins/consumerAuthentication";
import AskAppLoginConfirmation from "@/components/screener/enrollment/AskAppLoginConfirmation"
import CompanyBranding from "@/components/company/Branding"

export default {
  name: "OAuthLogin",
  props: ["dialog", "screener", "pricing"],
  components: {
    CompanyBranding,
    AskAppLoginConfirmation
  },
  data() {
    return {
      current_step: this.DEFINES.ENROLLMENT_STEPS.ASK_APP_LOGIN_CONFIRMATION,
      loading: false,
      complete: false,
      redirectURL: null
    };
  },

  computed: {
    ...mapState({
      company: (state) => state.company.company,
      session_key: (state) => state.auth.key,
      consumer: (state) => state.consumer.profile,
    }),
    ...mapGetters("company", {
      currentCompanyID: "getNavigationParamOfCompany",
    }),

     ...mapGetters("consumer", {
      isOAuthDomainApproved: "isOAuthDomainApproved",
    }),
    redirectURLHostName() {
      return new URL(this.$route.query.redirect_url).hostname
    }

  },
  mixins: [userCountryCode,consumerAuthentication],
  mounted() {
    this.mewOAuthLogin()
  },
  methods: {
    onComplete(code) {
      //
    },
    async mewOAuthLogin() {
      let oauth_host = new URL(this.$route.query.redirect_url)
      await this.$store.dispatch("auth/mewOAuthLogin",{
        company_id: this.company.id,
        oauth_host: oauth_host.origin + oauth_host.pathname,
        hostname: oauth_host.hostname
      })
      .then((response) => {
        if(this.$route.query && this.$route.query.redirect_url){
          this.redirectURL = this.$route.query.redirect_url+`&client_id=${this.company.id}&code=${response.token}`
          // if(this.isOAuthDomainApproved(this.redirectURLHostName)){
            window.location = this.redirectURL;
          // }
        }
      })
      .catch((error) => {
        console.error('Mew Login failed', error)
      })
      .finally(() => {
        //
      });
    },
    async onApprove() {
      await this.$store.dispatch('consumer/updateOAuthApprovedDomains',{
        hostname: this.redirectURLHostName
      })
      window.location = this.redirectURL;
    },
  },
};
</script>
<style scoped>
.card-style {
  border-radius: 10px !important;
  border-top: 5px solid var(--v-primary-base) !important;
}
</style>
